import styled from "styled-components";
import theme from "../../style/theme";

interface Props {
  placeholder?: string;
  name?: string;
  value: string | number | readonly string[] | undefined;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  width: string;
  ref?: React.Ref<HTMLInputElement>;
  isError?: boolean;
  disabled?: boolean;
}

export const GeneralTextField: React.FC<Props> = ({
  placeholder,
  name,
  value,
  onChange,
  width,
  ref,
  isError,
  disabled,
}) => {
  const resetPlaceholder =
    () => (event: React.FocusEvent<HTMLInputElement>) => {
      if (placeholder) {
        event.target.placeholder = placeholder;
      }
    };

  return (
    <TextField
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={resetPlaceholder}
      width={width}
      ref={ref}
      isError={isError}
      disabled={disabled}
    />
  );
};

interface TextFieldProps {
  width: string;
  isError?: boolean;
  disabled?: boolean;
}

const TextField = styled.input<TextFieldProps>`
  width: ${(props) => props.width};
  height: 42px;
  padding: 0;
  border: 1px solid
    ${(props) => {
      if (props.disabled) {
        return theme.palette.primitives.gray50;
      }
      if (props.isError) {
        return theme.palette.primitives.red500;
      }
      return theme.palette.primitives.gray300;
    }};
  border-radius: 4px;
  background: ${(props) =>
    props.disabled
      ? theme.palette.primitives.gray50
      : theme.palette.primitives.white};
  font-size: 14px;
  font-weight: 400;
  padding: 11px;
  box-sizing: border-box;
  outline: none;
  color: ${theme.palette.primitives.gray900};
  &::placeholder {
    color: ${theme.palette.primitives.gray300}};
  }
  &:focus {
    border: 1px solid #fcca00;
  }
`;
